(function (window, $, wNumb, RangeSlider, app) {
    var Math = window.Math;
    var JSON = window.JSON;
    
    function Range() {
        var _this = this;
        
        var defaults = {
            start: 0,
            connect: true,
            range: {
                min: 0,
                max: 100
            }
        };
        
        this.bind = function () {
            $('[data-input-range]').each(function () {
                _this.create(this);
            });
        };
        
        this.create = function ($el) {
            var id, slider, el, options, opts, data, fields;
            
            if (typeof $el === 'string') {
                id = $el;
                $el = $('#' + $el);
                
                if (! $el.length) {
                    throw new app.Exception('InvalidArgumentException', 'The element with the provided id could not be found.');
                }
            } else {
                if (! ($el instanceof $)) {
                    if (! ($el instanceof window.Element) && ! ($el instanceof window.HTMLCollection)) {
                        throw new app.Exception('InvalidArgumentException', 'The provided slider is not an instance of Element or HTMLCollection.');
                    }
                    
                    $el = $($el);
                }
                
                id = $el.attr('id');
                
                if (! id) {
                    throw new app.Exception('InvalidArgumentException', 'The provided slider does not have a valid id.');
                }
            }
            
            el = $el.get(0);
            data = $el.data();
            options = {};
            
            for (var key in data) {
                if (! data.hasOwnProperty(key) || key === 'inputRange' || key === 'fields') {
                    if (key === 'fields') {
                        fields = data[key];
                    }
                    
                    continue;
                }
                
                var deep = key;
                
                if (deep.match(/range\d+/)) {
                    deep = parseFloat(deep.replace(/range(\d+)/, '0.$1')) * 100;
                    deep = 'range.' + deep.toString().replace('.', ',') + '%';
                }
                
                options.setDeep(deep.toSnake().replace('_', '.'), data[key]);
            }
            
            options.mapKeys(function (key) {
                return key.replace(',', '.');
            }, true);
            
            if (options.hasOwnProperty('format')) {
                options.format = wNumb(options.format);
            }
            
            if (options.hasOwnProperty('pips')) {
                options.pips.format = {
                    to: function (num) {
                        return num > 999 ? num % 1000 === 0 ? (num / 1000).toFixed(0) + 'k' : (num / 1000).toFixed(1) + 'k' : num;
                    },
                    from: function (num) {
                        return num;
                    }
                };
            }
            
            opts = $.extend({}, defaults, options);
            
            RangeSlider.create(el, opts);
            
            slider = el.noUiSlider;
            
            console.log(fields, typeof fields);
            
            slider.on('update', function (values, handle) {
                var value = values[handle];
                var field = fields[handle];
                
                console.log(field, $(field), value);
                
                $(field).val(value);
            });
        };
    }
    
    app.registerModule('Range', new Range());
})(window, jQuery, wNumb, noUiSlider, app);
